// Auth tokens live in localStorage — the single source of truth the HTTP layer
// (fetchInstance, chunkUploader, the players) reads on every request. The
// profile store mirrors them for React consumers but never diverges from here.

export const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

// Fired whenever the access token is written, so consumers that keep a copy
// outside this module (the media service worker) can refresh theirs.
export const ACCESS_TOKEN_CHANGED_EVENT = "amoozim:access-token-changed";

const isBrowser = () => typeof window !== "undefined";

const read = (key: string): string | null => {
  if (!isBrowser()) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string | null) => {
  if (!isBrowser()) return;
  try {
    if (value) {
      window.localStorage.setItem(key, value);
    } else {
      window.localStorage.removeItem(key);
    }
  } catch {
    // localStorage can throw in private mode or when the quota is exceeded.
  }
};

const announceAccessTokenChange = () => {
  if (!isBrowser()) return;
  window.dispatchEvent(new Event(ACCESS_TOKEN_CHANGED_EVENT));
};

export const getAccessToken = (): string | null => read(ACCESS_TOKEN_KEY);
export const getRefreshToken = (): string | null => read(REFRESH_TOKEN_KEY);

export const setAccessToken = (token?: string | null) => {
  write(ACCESS_TOKEN_KEY, token ?? null);
  announceAccessTokenChange();
};
export const setRefreshToken = (token?: string | null) =>
  write(REFRESH_TOKEN_KEY, token ?? null);

export const clearTokens = () => {
  write(ACCESS_TOKEN_KEY, null);
  write(REFRESH_TOKEN_KEY, null);
  announceAccessTokenChange();
};
